export const baseUrl = 'https://canon.com.au/unlikelyunion';